<app-search-with-details [(searchInProgress)]="searchInProgress" [(sortField)]="currentSortField"  [fields]="fields" [sortColumns]="sortFields" [foundSet]="searchResults" (doSearch)="doSearch($event)" (doSort)="doSort($event)" (resultSelected)="practiceSelected($event)">
    <ng-template #details>
        <app-practice-editor [modelData]="selectedPractice"></app-practice-editor>
    </ng-template>
</app-search-with-details>
